import { telephoneRegex } from '@/helpers/common';

export default {
  validate: (value, { min = 10, max = 12, required = true }) => {
    if ([null, undefined, ''].includes(value)) {
      return {
        required,
        valid: !required,
      };
    }
    if (typeof value !== 'string') {
      return {
        required,
        valid: false,
      };
    }

    let isValid = true;
    const v = value ? value.replace('+44', '0') : value;

    if (
      !v ||
      !telephoneRegex.test(v) ||
      v.length < +min ||
      v.length > +max
    ) isValid = false;

    return {
      required,
      valid: isValid,
    };
  },
  params: ['min', 'max', 'required'],
  message: (fieldName, { _value_: v, min, max }) => {
    const defaultMsg = 'Please enter a valid phone number (e.g. 01234567890 or +441234567890).';
    if (!v || typeof v !== 'string') return defaultMsg;
    const digitsQty = v && v.replace('+44', '0').length;
    const is44 = v && (v.indexOf('+44') === 0);
    if (!v || !telephoneRegex.test(v)) return defaultMsg;
    if (digitsQty < +min) return `Telephone must contain at least ${is44 ? +min + 2 : min} characters.`;
    if (digitsQty > +max) return `Telephone must contain a maximum of ${is44 ? +max + 2 : max} characters.`;
    return defaultMsg;
  },
  computesRequired: true,
};
